import { createGlobalStyle } from "styled-components";
import { Theme } from "../../typedefs-ui/Theme";
import { debounce } from "lodash-es";

interface GlobalStylesProps {
  theme: Theme;
}

export const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  body {
    background-color: ${props => props.theme.background};
    font-family: ${props => props.theme.uiFont};
    margin: 0;
    padding: 0;
  }

  .no-scroll {
    overflow: hidden;
  }

  @media (hover: none) {
    a:hover {
      color: inherit !important;
    }
  }

  .relative {
    position: relative;
  }
`;

// NOTE: vh css unit is calculated differently in different browsers
// and event different versions of the same browser. Some choose to
// include the "chrome" or url/nav bars height allong with the view
// area's height to calculate the value, while others only use the
// view area's height. This causes problems where an element of 100vh
// will appear taller than the area viewable by a users. Since we
// need to be really precise about the height of our scripture area
// on mobile to avoid double scroll bars, we're calculating below
// a --vh variable using a value based on the window.innerHeight
// which provides us the consistancy we need accross browsers.
//
// for more information on this solution, see:
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
//
// USAGE: provide a default if css variables aren't available
// `height: 100vh;`
// then set the desired style for modern browsers:
// `calc(var(--vh, 1vh) * 100)`
// setting the 1vh as the second param to var sets a default
// in the case our --vh isn't defined or gets unset

const setCssVhVar = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setCssVhVar();
window.addEventListener("resize", debounce(setCssVhVar, 100));
